import { Injectable } from '@angular/core';
import { Location } from '@angular/common';

import { Logout } from './logout.model';
import {AuthServerProvider} from '../core/auth/auth-session.service';
import {environment} from '../../environments/environment';
import { KeycloakService } from 'keycloak-angular';
import { CookieService } from 'ngx-cookie-service';

@Injectable({ providedIn: 'root' })
export class LoginService {
  constructor ( private cookiesService : CookieService , private location: Location,private keycloakService: KeycloakService, private authServerProvider: AuthServerProvider,readonly keycloak: KeycloakService) {}
   
  login(): void {
    // If you have configured multiple OIDC providers, then, you can update this URL to /login.
    // It will show a Spring Security generated login page with links to configured OIDC providers.
    location.href = location.origin+`/api/oauth2/authorization/oidc`;
  }

  logout(): void {

    this.keycloakService.getToken().then(x=>{

      this.authServerProvider.logout(x).subscribe((logout: Logout) => {
 location.href=logout.logoutUrl;
      });
    });

  }

  getRoles()
  {
    return this.keycloakService.getUserRoles();
  }
}
